import { QueryClient, QueryClientProvider } from "@tanstack/solid-query";
import type { JSXElement } from "solid-js";

export const RRQueryClientProvider = (props: { children: JSXElement }) => {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: 60 * 1000 * 5,
      },
    },
  });
  return (
    <QueryClientProvider client={client}>{props.children}</QueryClientProvider>
  );
};
